export default {
  AsterCampaign: {
    getdata: [],
  },
};
